import React, { ReactNode, useEffect } from 'react';

import { RumInitConfiguration } from '@datadog/browser-rum';
import { getRuntimeEnv } from '@explorer/helpers';

import Monitoring from '@crucible-risk/react-monitoring';

export const SEGMENT_PREFIX = 'XPLR';

const DEV_ENV = 'development';

export const AppMonitoring = ({
  userId,
  userEmail,
  userName,
  children,
  datadogConfig,
  errorView,
  segmentKey,
  sentryKey,
}: AppMonitoringProps) => {
  const segmentEventPrefix = SEGMENT_PREFIX;
  const reactEnv = getRuntimeEnv('REACT_ENV');
  const isLocalhost = reactEnv === DEV_ENV || reactEnv === 'test';
  const environment = isLocalhost ? DEV_ENV : getRuntimeEnv('BE_ENV');
  const appVersion = getRuntimeEnv('REACT_APP_VERSION', 'dev');

  useEffect(() => {
    if (isLocalhost) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log({ version: appVersion });
  }, [isLocalhost, appVersion]);

  return (
    <Monitoring
      datadogApplicationId={datadogConfig.appId ?? ''}
      datadogClientToken={datadogConfig.token ?? ''}
      datadogService={datadogConfig.serviceName ?? ''}
      environment={environment}
      ErrorBoundaryFallback={errorView}
      segmentEventPrefix={segmentEventPrefix}
      segmentWriteKey={segmentKey}
      sentryDsn={sentryKey}
      userEmail={userEmail}
      userId={userId}
      userName={userName}
      version={appVersion}
      datadogAllowedTracingOrigins={datadogConfig.tracingOrigins}
    >
      {children}
    </Monitoring>
  );
};

export interface AppMonitoringProps {
  userId: string;
  userEmail?: string;
  userName?: string;
  children: ReactNode;
  datadogConfig: {
    appId?: string;
    token?: string;
    serviceName?: string;
    tracingOrigins?: RumInitConfiguration['allowedTracingUrls'];
  };
  errorView: any;
  segmentKey: string;
  sentryKey: string;
}
